<template>
	<section class="schedule-box">

		<!-- Шапка -->
		<div class="header">
			<!-- Название месяца -->
			<div class="hours-col">
				<div class="hour monthName">
					{{monthName | threeLetters}}
				</div>
			</div>

			<!-- Левая стрелка -->
			<div class="content-col left_arrow">
				<img src="../../../../assets/img/svg/agenda-left.svg" class="days_decor" @click="clickLeft">
			</div>
			<!-- Конец Левая стрелка -->
			<!-- Дни -->
			<div class="content-col" :style="{'width': calcWidth(dayCount)}" v-for="day in daysArray">
				<div class="day days_decor day_shadow transition" :class="{'current': day === today}">
					{{[day, 'DD-MM-YYYY dd'] | moment('DD dd')}}
				</div>
			</div>

			<!-- Правая стрелка -->
			<div class="content-col right_arrow">
				<img src="../../../../assets/img/svg/agenda-right.svg" class="days_decor" @click="clickRight">
			</div>
			<!-- Конец Правая стрелка -->
		</div>

		<!-- Тело календаря -->
		<div class="time-line">
			<!-- Список докторов -->
			<div class="hours-col main">
				<div class="hour" v-for="doctor in doctorList">
					<p class="time_color">
						{{doctor.user_last_name}} {{doctor.user_first_name | one}} {{doctor.user_middle_name | one}}
					</p>
				</div>
			</div>

			<!-- Столбци дней -->
			<div class="content-col" :style="{'width': calcWidth(dayCount), color: 'black'}" v-for="day in daysArray">
				<router-link
					:to="{name: 'Registry', query: {id: doctor._id, start_day: dayForQuery(day)}}"
					class="day"
					v-for="(doctor, index) in doctorList"
					:key="doctor._id"
					@click="clickScheduler(doctor)"
				>
					<horizontal-event
						v-if="agendaList[index]"
						:dayAgenda="agendaList[index][parseDay(day)]"
						:schedule="getDoctorSchedule(doctor, day)"
					/>
					<div>
						{{day.slice(0,2)}}
					</div>
				</router-link>
			</div>

			<!-- Визиты доктора-->
			<!--TODO here is bad code. need to fix-->
			<div v-for="event in events"
					 :style="calcEventStyles(event)"
					 v-if="event.status !== 'canceled'"
					 @click="clickEvent(event)"
					 @contextmenu.prevent
					 @contextmenu="openStatus(event, this.posX = $event.clientX, this.posY = $event.clientY)"
					 class="event pointer">
			</div>
		</div>
	</section>

</template>

<script>
	import moment from 'moment';
	import _ from 'underscore';

	import HorizontalEvent from './HorizontalEvent.vue';

	import {
		eventColors
	} from '../../../../common';

	export default {
		name: 'GeneralScheduler',
		props: ['initialState', 'doctorList', 'agendaList', 'updateAgenda'],
		components: {
			'horizontal-event': HorizontalEvent,
		},
		filters: {
			threeLetters(val) {
				if (val) {
					return val.slice(0, 3);
				}
			},
		},
		computed: {
			clinicId() {
				return this.$route.query.clinic;
			},
			daysArray() {
				let start = moment(this.start, 'DD-MM-YYYY dd'), arr = [];

				for (let i = 0; i < this.dayCount; i++) {
					arr.push(start.add((i) ? 1 : 0, 'days').format('DD-MM-YYYY dd'));
				}

				return arr;
			},
			monthName() {
				if (this.start) {
					return moment(this.start, 'DD-MM-YYYY').format('MMM');
				}
			},
		},
		mounted() {
			this.start = moment().format('DD-MM-YYYY');
			this.checkInitialData(this.initialState);
		},
		data() {
			return {
				today: moment().format('DD-MM-YYYY dd'),
				start: '',
				dayCount: 5,
				events: [],
				posX: 54,
				posY: 33,
				isMove: false,
				isInquiry: false,
				showContext: false,
				tmpVisit: {},
				draggedEvent: {},
				schedulerTime: {
					start: {
						hour: 7,
						minute: 0,
					},
					end: {
						hour: 21, // max 23
						minute: 59,
					},
				},
			};
		},
		methods: {
			calcEventStyles(event) {
				if (event.priority)
					return {
						'top': this.calcPosition(event.begin) + 'px',
						'height': this.calcHeight(event.begin, event.end) + 'px',
						'width': this.calcEventWidth(this.dayCount, event.priority),
						'background': eventColors[event.status],
						'left': this.calcLeft(event.begin, event.priority) + 'px',
						'box-shadow': (event.priority <= 1) ? 'none' : '0 0 3px gray',
					};

				return {
					'top': this.calcPosition(event.begin) + 'px',
					'height': this.calcHeight(event.begin, event.end) + 'px',
					'width': this.calcEventWidth(this.dayCount),
					'background': eventColors[event.status],
					'left': this.calcLeft(event.begin) + 'px',
				};
			},

			clickScheduler(day, time, doctor) {
				if (!day || !time) {

					return;
				}

				if (!this.isClosedTime(day)) {
					this.$event.toast('i', 'Вы не можете сделать запись на прошлый день или на 4 недели позднее сегодня');

					if (this.isMove) {
						this.tmpVisit = {};
						this.isMove = false;
					}

					return false;
				}

				if (this.isMove) {
					this.moveEvent(day, time, this.tmpVisit, doctor);
				} else if (this.isInquiry) {
					this.tmpVisit.begin = moment(day + ' ' + time, 'DD-MM-YYYY HH:mm').format('X');
					this.tmpVisit.isInquiry = true;
					this.$event.send('openEditModal', _.clone(this.tmpVisit), doctor);

					this.tmpVisit = {};
					this.isInquiry = false;
				} else {
					this.$event.send('openEditModal', {
						begin: moment(day + ' ' + time, 'DD-MM-YYYY HH:mm').format('X'),
					}, doctor);
				}
			},
			clickEvent(event) {
				this.$event.send('openDetailsModal', event);
			},

			/**
			 * Moving event to new date and time
			 * @param {string} day
			 * @param {string} time
			 * @param {object} event
			 * @param {object} doctor
			 */
			moveEvent(day, time, event, doctor) {
				let begin = moment(day + ' ' + time, 'DD-MM-YYYY HH:mm').format('X');
				let duration = moment(event.end, 'X').diff(moment(event.begin, 'X'), 'minutes');

				this.$store.dispatch('agenda/update', {
					id: event._id,
					begin: begin,
					end: moment(begin, 'X').add(duration, 'minutes').format('X'),
				}).then(() => {
					this.$event.send('updateEvents', doctor._id);
					this.isMove = false;
					this.tmpVisit = {};
				});
			},

			/**
			 * concat all events from all days to one array for render
			 * @param {Array} days
			 * @returns {Array}
			 */
			concat(days) {
				return _.uniq(_([]).concat(..._.toArray(days)));
			},

			/**
			 * Getting one day
			 * @param day
			 * @returns {boolean}
			 */
			replaceEvents(day) {
				if (!day.length) {
					return false;
				}

				day = _.sortBy(day, 'begin');

				_.map(day, (item, index) => {
					let arrForSend;

					arrForSend = this.compareVisitWithOther(index, day);

					this.changeSizeOfEvents(arrForSend, true);

					delete day[index];
				});
			},

			/**
			 * Takes one visit and compare with other visits in array
			 * @param index {number | string}
			 * @param day
			 * @returns {Array}
			 */
			compareVisitWithOther(index, day) {
				let arr = [], id;

				for (let i = index + 1; i <= day.length - 1; i++) {
					id = this.compareTwoEvents(day[index], day[i]);

					if (id) {
						this.changeSizeOfEvents([day[index]._id], false);
						arr.push(id);
					}
				}

				return arr;
			},

			/**
			 * Compares two visits
			 * @param one {object} - first visit
			 * @param two {object} - second visit
			 * @returns {*}
			 */
			compareTwoEvents(one, two) {
				if (!one || !two) {
					return false;
				}

				if (one.begin <= two.begin && two.begin <= one.end) {
					return two._id;
				} else if (one.begin <= two.end && two.end <= one.end) {
					return two._id;
				}

				return false;
			},

			changeSizeOfEvents(eventIds) {
				if (!eventIds.length)
					return false;
			},

			calcPosition(start) {
				const step = 15; // step in minutes (can be changed, but it should recalc number of pixels below)
				const pixelCount = 25; // height of step in pixels (changing of step also changes pixel count)

				if (start) {
					// needs in this record style because we need time without date and seconds
					let currentTime = moment(start, 'X').format('HH:mm');
					let startTime = moment(this.schedulerTime.start);
					return moment(currentTime, 'HH:mm').diff(startTime, 'minutes') / step * pixelCount;
				}
			},
			calcHeight(start, end) {
				if (start && end) {
					return moment(end, 'X').diff(moment(start, 'X'), 'minutes') * 1.666666666 - 5;
				}
			},
			calcWidth(dayCount) {
				return 'calc((100% - 150px)/' + dayCount + ')';
			},
			calcEventWidth(dayCount, d) {

				d -= 1;
				d /= 20;
				d = 1 - d;

				if (d) {
					return 'calc(((100% - 150px)/' + dayCount + '*0.90)*' + d + ')';
				}

				return 'calc((100% - 150px)/' + dayCount + '*0.90)';
			},
			calcLeft(start, d) {
				if (!start) return false;

				let currentTime, startTime, difference, x, oneBlock, result, margin;

				currentTime = moment(start, 'X');
				startTime = moment(this.start, 'DD-MM-YYYY');
				difference = currentTime.diff(startTime, 'days');
				x = document.getElementsByClassName('time-line')[0].offsetWidth;
				oneBlock = (x - 52) / this.dayCount;

				if (d) {
					margin = oneBlock - (oneBlock / (1 + (d / 5)));
				}

				result = (oneBlock * difference) + 52;

				return result;
			},
			calcTime(time, e) {
				let part = Math.floor(e.offsetY / 25);
				let newMinutes = part * 15;

				return moment(time, 'HH:mm').add(newMinutes, 'minutes').format('HH:mm');
			},
			clickLeft() {
				this.start = moment(this.start, 'DD-MM-YYYY')
					.subtract(this.dayCount, 'days')
					.format('DD-MM-YYYY');

				this.updateAgenda(undefined, this.start);
			},
			clickRight() {
				this.start = moment(this.start, 'DD-MM-YYYY')
					.add(this.dayCount, 'days')
					.format('DD-MM-YYYY');

				this.updateAgenda(undefined, this.start);
			},
			scrollTop(margin) {
				let el = document.getElementsByClassName('time-line')[0];
				el.scrollTop = margin - 200;
			},
			isClosedTime(day) {
				let todayMoment = moment(this.today, 'DD-MM-YYYY');
				let selectedDayMoment = moment(day, 'DD-MM-YYYY');
				let lastDay = moment(this.today, 'DD-MM-YYYY').add(28, 'days');

				return (selectedDayMoment.isSameOrAfter(todayMoment, 'days') && selectedDayMoment.isBefore(lastDay, 'days'));
			},

			openStatus(event, posX, posY) {
				const model = { event, posX, posY };
				this.$event.send('openStatusModal', model);
			},

			checkInitialData(data = {}) {
				Object.entries(data).forEach(([key, value]) => {
					if (this.$data[key]) {
						this[key] = value;
					}
				});
			},

			dayForQuery(day) {
				return moment(day, 'DD-MM-YYYY dd').format('X');
			},

			getDoctorSchedule(doctor, day) {
				const dayIndex = moment(day, 'DD-MM-YYYY dd').format('E');
				return doctor.schedule && doctor.schedule[dayIndex];
			},

			parseDay(day) {
				const primal = day.slice(0, 2);
				return +primal[0] === 0 ? primal[1] : primal;
			}
		},
	};
</script>

<style lang="scss" scoped>
	body {
		background: #eee;
	}

	.schedule-box {
		position: relative;
		height: 100%;
		overflow: hidden;
	}

	.header {
		padding-top: 5px;
		position: relative;
		height: 51px;
		top: 0;
		left: 0;
		right: 0;
		background-color: #06a6c9;
		z-index: 55;
	}

	.time-line {
		width: 100%;
		height: calc(100% - 51px);
		position: relative;
		overflow: auto;
		background: #fff;
		margin-top: -1px;
		user-select: none;
	}

	.doctor-title {
		position: relative;
		height: 33px;
		background: #68cae0;
	}

	.doctor-title p {
		text-align: center;
		color: #ffffff;
		font-size: 16px;
		padding: 4px;
		border-bottom: 1px solid #fff;
	}

	.time-block {
		color: #999;
		height: 50px;
		width: 45px;
		text-align: center;
		padding: 0 5px;
		border-right: 1px solid #d6d6d6;
		float: left;
	}

	.content-block {
		height: 49px;
		width: calc(100% - 56px);
		float: right;
		border-top: 1px solid #d6d6d6;
	}

	.time-block > .time {
		margin-top: -10px;
	}

	.event-container {
		display: block;
	}

	.event {
		position: absolute;
		top: 32%;
		left: 58px;
		width: 80%;
		background: #888;
		border-radius: 0;
		height: 30px;
		color: white;
		line-height: 16px;
		box-shadow: 1px 1px 6px 0 #999999;
		overflow: hidden;
	}

	.hours-col {
		float: left;
		width: 148px;
		color: #ffffff;

		.hour {
			box-sizing: border-box;
			width: 100%;
			padding: 0 5px;
			text-align: center;
			height: 50px;
			line-height: 50px;
			text-transform: uppercase;
		}
	}

	.hours-col.main {
		.hour {
			line-height: 0;
			box-shadow: 0 0 1px 0 #06c6a9;
		}
	}

	.content-col {
		float: left;
		height: 50px;
		line-height: 50px;
		text-align: center;
	}

	.hour.not-work-time {
		background: #999;
	}

	.day {
		height: 50px;
		text-align: center;
		width: 100%;
		box-sizing: border-box;
		box-shadow: 0 0 1px 0 #06c6a9;
		color: #ffffff;
		font-weight: 700;
		text-transform: capitalize;
	}

	.not-work-time {
		background: #e8e8e8;
		pointer-events: none;
	}

	.current {
		/*background: #FE3B2C;*/
		color: #FE3B2C;
		box-shadow: 0 0 2px 0 #FE3B2C;
	}

	.days_decor {
		width: 48px;
		height: 32px;
		border-radius: 50%;
		line-height: 32px;
		display: inline-block;
		cursor: pointer;
	}

	.current-time {
		position: absolute;
		width: 100%;
		height: 16px;

		.time {
			color: red;
			width: 51px;
			float: left;
			text-align: center;
			background: #fff;
		}

		.line {
			height: 1px;
			float: left;
			line-height: 16px;
			background: red;
			width: calc(100% - 55px);
			margin-top: 8px;
		}
	}

	.day_shadow {
		/*box-shadow: 0 0 0 1px #ffffff;*/
	}

	.current {
		box-shadow: 0 0 0 1px #FE3B2C;
	}

	.time_color {
		font-size: 12px;
		color: #272727;
		padding-top: 25px;
		text-transform: capitalize;
		text-align: left;
		padding-left: 12px;
	}

	.left_arrow {
		& > .days_decor {
			position: absolute;
			left: 145px;
			height: 25px;
			top: 17px;
		}
	}

	.right_arrow {
		& > .days_decor {
			position: absolute;
			right: -5px;
			height: 25px;
			top: 17px;
		}
	}

</style>



// WEBPACK FOOTER //
// GeneralSchedule.vue?064ad003